import request from '@/utils/request'

/**
 *  个人模块 api
 */
// 员工列表
export const getEmployeeListApi = params =>
  request({
    url: '/consultConsultant/consult/list',
    method: 'get',
    params
  })
export const getConsultAppointmentListApi = params =>
  request({
    url: '/consultConsultant/consult/appointment/records',
    method: 'get',
    params
  })
export const getAppointmentDesc = params =>
  request({
    url: '/consultConsultant/consult/appointment/describe',
    method: 'get',
    params
  })
// 预约提交
export const postAppointment = params =>
  request({
    url: '/consultConsultant/consult/appointment',
    method: 'post',
    data: JSON.stringify(params)
  })
// 预约详情
// 员工详情
export const getEmployeeDetailApi = params =>
  request({
    url: `/employee/detail/${params.employeeId}`,
    method: 'get'
  })
// 作品详情
export const getEmployeePortfolioDetailApi = params =>
  request({
    url: `/employee/portfolio/detail/${params.portfolioId}`,
    method: 'get'
  })
// 新增作品
export const employeePortfolioCreateApi = params =>
  request({
    url: `/employee/portfolio/create`,
    method: 'post',
    data: JSON.stringify(params)
  })
// 删除案例
export const employeenPortfolioDeleteApi = params =>
  request({
    url: `/employee/portfolio/delete/${params.employeeId}`,
    method: 'delete'
  })

// 修改作品排序
export const employeePortfolioSortApi = params =>
  request({
    url: `/employee/portfolio/sort`,
    method: 'put',
    data: JSON.stringify(params)
  })

// 修改作品图片排序数
// export const employeePortfolioSortApi = params =>
//   request({
//     url: `/employee/portfolio/modifyPic/sort`,
//     method: 'put',
//     data: JSON.stringify(params)
//   })

/**
 *   我的相关
 */

// 修改信息
export const employeeUpdateApi = params =>
  request({
    url: `/employee/update`,
    method: 'put',
    data: JSON.stringify(params)
  })

export const userModifyInfoApi = params =>
  request({
    url: `/user/modifyInfo`,
    method: 'put',
    data: JSON.stringify(params)
  })
// 员工入驻
export const employeeEnterApi = params =>
  request({
    url: `/employee/enter`,
    method: 'post',
    data: JSON.stringify(params)
  })
// 入驻审核
export const employeeCheckApi = params =>
  request({
    url: `/employee/check`,
    method: 'put',
    data: JSON.stringify(params)
  })
// 邀请入团
export const employeeInviteApi = params =>
  request({
    url: `/employee/invite/${params.teamId}/${params.employeeId}/${params.inviterId}`,
    method: 'post',
    data: JSON.stringify(params)
  })
// 入团邀请列表
export const getEmployeeInviteListApi = params =>
  request({
    url: `/employee/inviteList/${params.employeeId}`,
    method: 'get'
  })
// 邀请入团同意
export const employeeInviteAgreeApi = params =>
  request({
    url: `/employee/invite/agree/${params.teamId}/${params.employeeId}`,
    method: 'put'
  })
// 邀请入团拒绝
export const employeeInviteRejectApi = params =>
  request({
    url: `/employee/invite/reject/${params.teamId}/${params.employeeId}`,
    method: 'put'
  })
// 邀请入团删除
export const employeeInviteDeleteApi = params =>
  request({
    url: `/employee/invite/delete/${params.teamId}/${params.employeeId}`,
    method: 'delete'
  })
// 我的钱包
export const getMyWalletApi = () =>
  request({
    url: `/userAccount/wallet`,
    method: 'get'
  })
// 首页可用代金券
export const getMyCouponListApi = () =>
  request({
    url: `coupon/queryCurrentUserAvailableCoupons`,
    method: 'get'
  })
// 更多代金券
export const getMyAllCouponListApi = () =>
  request({
    url: `/coupon/queryCurrentUserTotalCoupons`,
    method: 'get'
  })
// 可领取的代金券
export const getAvailableCouponListApi = () =>
  request({
    url: `/coupon/queryCurrentUserDailyRetakeCoupons`,
    method: 'get'
  })
// 领券
export const handleGetCouponApi = params =>
  request({
    url: `/coupon/getCoupons`,
    method: 'post',
    data: JSON.stringify(params)
  })

// 咨询师开通
export const consultOpenApi = () =>
  request({
    url: '/consultConsultant/consult/open',
    method: 'post'
  })

// 咨询师开通状态校验
export const checkConsultOpenStatusApi = () =>
  request({
    url: '/consultConsultant/consult/checkOpen',
    method: 'post'
  })

// 获取关注列表
export const getFollowedListApi = params =>
  request({
    url: '/fans/followedList',
    method: 'get',
    params
  })

// 取消关注
export const unfollowApi = params =>
  request({
    url: '/fans/cancelFollowed',
    method: 'post',
    data: JSON.stringify(params)
  })
